// Vendors
import React from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Types
import { LoadingState } from '@appTypes/loadingstates';
// Context
import { MessagingState } from '@context/Context';
import { ActionType } from '@context/ActionTypes';
// Components
import CustomIcon from '@components/ui/CustomIcon';
// Hooks
import useModal from '@components/hooks/useModal';

interface IThreadActionButtonsProps {
    modalConfirmed: boolean;
    isSubmitting: boolean;
    amplitudeProps: { guid_id: string };
}

const ThreadActionButtons = ({ modalConfirmed, isSubmitting, amplitudeProps }: IThreadActionButtonsProps) => {
    const { dispatch } = MessagingState();
    const navigate = useNavigate();
    const { folderParam, pageNumber } = useParams();
    const modal = useModal();
    const { t } = useTranslation();

    const onCancel = () => {
        amplitude.track('new_message_cancelled', amplitudeProps);
        dispatch({
            type: ActionType.SET_ACTIVE_DISCUSSIONTHREAD,
            payload: { thread: null, loadingState: LoadingState.Done },
        });
        dispatch({
            type: ActionType.SET_MESSAGE,
            payload: {
                title: '',
                recipients: [],
                message: '',
                seeNames: false,
                seeResponses: false,
            },
        });
        dispatch({
            type: ActionType.SET_SELECTED_RECIPIENTS,
            payload: { options: [] },
        });
        navigate({
            pathname: `/${folderParam}/page/${pageNumber}`,
            search: location.search,
        });
    };

    return (
        <div>
            <div className="float-right">
                <button
                    type="button"
                    disabled={isSubmitting || modal.isOpen || modalConfirmed}
                    className="btn bg-transparent action-button"
                    onClick={onCancel}
                    aria-disabled={isSubmitting || modal.isOpen || modalConfirmed}>
                    <CustomIcon
                        icon="close"
                        className="icon-spacing"
                    />
                    {t('cancel')}
                </button>
                <button
                    type="submit"
                    disabled={isSubmitting || modal.isOpen || modalConfirmed}
                    className="btn btn-primary bg-secondary action-button"
                    aria-disabled={isSubmitting || modal.isOpen || modalConfirmed}>
                    <CustomIcon
                        icon="paperplane"
                        className="icon-spacing"
                    />
                    {t('submitMessage')}
                </button>
                {(isSubmitting || modal.isOpen || modalConfirmed) && (
                    <span className="spinner spinner-sm spinner-default-blue"></span>
                )}
            </div>
        </div>
    );
};

export default ThreadActionButtons;
